export default {
  list(params) {
    return Request.get('api/company/client', params);
  },
  listHistory(params) {
    return Request.get('api/company/client/history', params);
  },
};
